import React from 'react';
import { makeStyles } from 'tss-react/mui';
import clsx from 'clsx';
import Icon from '../../../base/icons/components/Icon';
import { IconRaiseHand } from '../../../base/icons/svg';
import { getRaisedHandPosition } from '../../functions';
import { connect } from 'react-redux';
const useStyles = makeStyles()(theme => {
    return {
        indicator: {
            backgroundColor: theme.palette.warning02,
            borderRadius: `${Number(theme.shape.borderRadius) / 2}px`,
            height: '20px',
            width: '40px',
            padding: '0 !important',
            display: 'flex',
        },
        indicatorText: {
            color: theme.palette.icon04,
            flexGrow: 1,
        }
    };
});
function RaisedHandIndicator({ participantID, state }) {
    const { classes: styles, theme } = useStyles();
    const raisedHandPosition = getRaisedHandPosition(state, participantID);
    const iconStyle = {
        display: 'inline',
        flexGrow: 1,
    };
    return (React.createElement("div", { className: clsx(styles.indicator, 'raised-hand-indicator') },
        React.createElement(Icon, { color: theme.palette.icon04, size: 16, src: IconRaiseHand, style: iconStyle }),
        React.createElement("span", { className: clsx(styles.indicatorText) }, raisedHandPosition)));
}
;
function _mapStateToProps(state) {
    return {
        state: state,
    };
}
export default connect(_mapStateToProps)(RaisedHandIndicator);
